
import { Vue, Component, Watch } from 'vue-property-decorator';
import Api from '@/services/api';

@Component
export default class GroupRuns extends Vue {
  public formTitle = 'تاریخچه اجرای گروه ها';
  public items: any[] = [];
  public groups = [];
  public expanded: any[] = [];
  public groupId: number | null = null;
  public outcome: number | null = null;
  public take = 50;
  public autoRefresh = false;
  private timer: any = null;

  public outcomeItems = [
    { text: 'در حال اجرا', value: 0 },
    { text: 'موفق', value: 1 },
    { text: 'قطع‌شده (اولویت)', value: 2 },
    { text: 'ناموفق', value: 3 },
    { text: 'لغو شده', value: 4 }
  ];

  public headers = [
    { text: 'گروه', value: 'group' },
    { text: 'شروع', value: 'startedAt' },
    { text: 'مدت', value: 'duration', sortable: false },
    { text: 'وضعیت', value: 'outcome' },
    { text: 'کل سیم', value: 'simsTotal' },
    { text: 'موفق', value: 'simsRefreshed' },
    { text: 'خطا', value: 'simsRefreshFailed' },
    { text: '', value: 'data-table-expand' }
  ];

  public breadcrumbItems = [
    { text: 'صفحه اصلی', disabled: false, href: '/' },
    { text: 'مدیریت گروه ها', disabled: false, href: '/group' },
    { text: 'تاریخچه اجرا', disabled: true, href: '' }
  ];

  get summary() {
    const count = (o: number) => this.items.filter((x: any) => x.outcome === o).length;
    return { running: count(0), completed: count(1), preempted: count(2), failed: count(3) };
  }

  async created() {
    this.$showLoading();
    await Api.getGroupShortList().then((response: any) => {
      this.groups = response.data;
    });
    this.$hideLoading();

    // اگر از صفحه جزئیات گروه آمده باشیم
    if (this.$route.query.groupId) this.groupId = parseInt(this.$route.query.groupId as string);

    await this.getData();
  }

  beforeDestroy() {
    this.stopTimer();
  }

  @Watch('autoRefresh')
  onAutoRefreshChange(val: boolean) {
    this.stopTimer();
    if (val) this.timer = setInterval(() => this.getData(true), 30000);
  }

  stopTimer() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  async getData(silent = false) {
    if (!silent) this.$showLoading();
    try {
      const response: any = await Api.getGroupRuns({
        groupId: this.groupId || undefined,
        outcome: this.outcome,
        take: this.take
      });
      this.items = response.data;
    } finally {
      if (!silent) this.$hideLoading();
    }
  }

  reset() {
    this.groupId = null;
    this.outcome = null;
    this.take = 50;
    this.getData();
  }

  outcomeTitle(o: number) {
    return this.outcomeItems.find((x) => x.value === o)?.text ?? '-';
  }

  outcomeColor(o: number) {
    return ['blue', 'green', 'orange', 'red', 'grey'][o] ?? 'grey';
  }

  duration(item: any) {
    if (!item.startedAt) return '-';
    const start = new Date(item.startedAt).getTime();
    const end = item.finishedAt ? new Date(item.finishedAt).getTime() : Date.now();
    const sec = Math.max(0, Math.floor((end - start) / 1000));
    const h = Math.floor(sec / 3600);
    const m = Math.floor((sec % 3600) / 60);
    const s = sec % 60;
    if (h > 0) return `${h} ساعت و ${m} دقیقه`;
    if (m > 0) return `${m} دقیقه و ${s} ثانیه`;
    return `${s} ثانیه`;
  }
}
